<template>
  <v-row>
    <v-col cols="12">
      <!-- fast state -->
      <v-card>
        <v-tabs background-color="background" color="primary" grow height="55" slider-size="4">
          <v-tab class="text-none font-weight-medium" to="/transactions" exact>Todos los movimientos</v-tab>
          <v-divider vertical />
          <v-tab class="text-none font-weight-medium" to="/transactions?status=pending" exact>Pendiente</v-tab>
          <v-divider vertical />
          <v-tab class="text-none font-weight-medium" to="/transactions?status=finalized" exact>Conciliado</v-tab>
        </v-tabs>
      </v-card>
      <!-- end fast state -->

      <v-card class="px-0 mt-5">
        <v-skeleton-loader v-if="$store.state.banks.retrieveLoader" transition="fade-transition" type="toolbar" />
        <v-toolbar v-else color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Transferencias</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-1">
              <v-query-builder :query-map="filters" model="transactions" />
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="px-0 py-0">
          <transaction-list :show-create="true" />
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import { transfersFilters } from '../../collections/queryBuilderFilters'
import TransactionList from '@/components/bank/TransactionList'
import VQueryBuilder from '@/components/VQueryBuilder/VQueryBuilder'
import ListViewMixin from '@/mixins/ListViewMixin'

export default {
  components: {
    TransactionList,
    VQueryBuilder
  },
  mixins: [
    ListViewMixin
  ],
  data: () => ({
    filters: transfersFilters
  }),
  methods: {
    getList (loader = true) {
      this.$store.dispatch('banks/LIST', {
        resource: 'ach_transfers',
        query: this.$route.query,
        loader: loader
      })
    }
  }
}
</script>